import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "row pt-3",
  style: {"border-top":"1px dashed rgba(106, 113, 133, 0.3)"}
}
const _hoisted_2 = { class: "col-sm-5" }
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = { class: "f-w-700 pb-1" }
const _hoisted_5 = { class: "col-sm-7" }
const _hoisted_6 = { class: "row h-100" }
const _hoisted_7 = { class: "col h-100" }
const _hoisted_8 = { class: "checkbox-checked d-flex h-100 align-items-center" }
const _hoisted_9 = { class: "form-check" }
const _hoisted_10 = {
  class: "form-check-label",
  for: "show-on-menu"
}
const _hoisted_11 = { class: "col h-100" }
const _hoisted_12 = { class: "checkbox-checked d-flex h-100 align-items-center" }
const _hoisted_13 = { class: "form-check" }
const _hoisted_14 = {
  class: "form-check-label",
  for: "sele-department"
}
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col-sm-5" }
const _hoisted_17 = { class: "mb-3" }
const _hoisted_18 = { class: "f-w-700" }
const _hoisted_19 = ["placeholder"]
const _hoisted_20 = { class: "col-sm-7" }
const _hoisted_21 = { class: "mb-3" }
const _hoisted_22 = { class: "f-w-700" }
const _hoisted_23 = ["placeholder"]
const _hoisted_24 = { class: "row" }
const _hoisted_25 = { class: "col-sm-5" }
const _hoisted_26 = { class: "mb-3" }
const _hoisted_27 = { class: "f-w-700" }
const _hoisted_28 = { class: "input-group" }
const _hoisted_29 = {
  value: "",
  disabled: ""
}
const _hoisted_30 = ["value"]
const _hoisted_31 = { class: "row mb-3" }
const _hoisted_32 = { class: "col-5" }
const _hoisted_33 = { class: "f-w-700" }
const _hoisted_34 = { class: "input-group" }
const _hoisted_35 = ["placeholder"]
const _hoisted_36 = {
  class: "col-sm-7",
  style: {"margin-top":"30px"}
}
const _hoisted_37 = { class: "row h-100" }
const _hoisted_38 = { class: "col h-100" }
const _hoisted_39 = { class: "checkbox-checked d-flex h-100 align-items-center" }
const _hoisted_40 = { class: "form-check" }
const _hoisted_41 = {
  class: "form-check-label",
  for: "service-check"
}
const _hoisted_42 = { class: "col h-100" }
const _hoisted_43 = { class: "checkbox-checked d-flex h-100 align-items-center" }
const _hoisted_44 = { class: "form-check" }
const _hoisted_45 = {
  class: "form-check-label",
  for: "surchargeable-check"
}
const _hoisted_46 = { class: "row" }
const _hoisted_47 = { class: "col-sm-5" }
const _hoisted_48 = { class: "checkbox-checked h-100 d-flex h-100 align-items-center" }
const _hoisted_49 = { class: "form-check" }
const _hoisted_50 = {
  class: "form-check-label",
  for: "scale-check"
}
const _hoisted_51 = { class: "col-sm-7" }
const _hoisted_52 = { class: "mb-3" }
const _hoisted_53 = { class: "f-w-700" }
const _hoisted_54 = { class: "input-group" }
const _hoisted_55 = { value: "" }
const _hoisted_56 = { value: "Individually" }
const _hoisted_57 = { value: "Gram" }
const _hoisted_58 = { value: "Kilogram" }
const _hoisted_59 = { value: "Ounce" }
const _hoisted_60 = { value: "Pound" }
const _hoisted_61 = { value: "Milliliter" }
const _hoisted_62 = { value: "Liter" }
const _hoisted_63 = { value: "Pint" }
const _hoisted_64 = { value: "Quart" }
const _hoisted_65 = { value: "Gallon" }

import { computed, reactive, watch, onMounted, defineAsyncComponent } from 'vue'
import { useDepartmentsStore } from '@/store/management/departmentsStore';
import { useTaxesStore } from '@/store/management/taxesStore';
import type { Department } from '@/store/management/departmentsStore';

import { useI18n } from 'vue-i18n'
import { departmentsBasicLanguage } from '@/core/locales/departments-language';


export default /*@__PURE__*/_defineComponent({
  __name: 'departmentsBasic',
  setup(__props) {

const { t } = useI18n({
  messages: departmentsBasicLanguage
})

const departmentsAltLangModal = defineAsyncComponent(() => import('@/components/managementPages/dapartmentsPage/departmentsAltLangModal.vue'))

const departmentsStore = useDepartmentsStore()
const taxesStore = useTaxesStore();

onMounted(() => {
    taxesStore.initializeTaxes();
});

const taxList = computed(() => taxesStore.getTaxesList);

onMounted(() => {
    taxesStore.initializeTaxes();
    if (tempActiveDepartment.value?.id) {
        compState.id = tempActiveDepartment.value.id
        compState.no = tempActiveDepartment.value.no
        compState.name = tempActiveDepartment.value.name
        compState.showOnMenu = tempActiveDepartment.value.showOnMenu
        compState.saleDepartment = tempActiveDepartment.value.saleDepartment
        compState.taxRate = tempActiveDepartment.value.taxRate
        compState.displayOrder = tempActiveDepartment.value.displayOrder
        compState.nonDiscountable = tempActiveDepartment.value.nonDiscountable
        compState.nonSurchargeable = tempActiveDepartment.value.nonSurchargeable
        compState.scaleDepartment = tempActiveDepartment.value.scaleDepartment
        compState.unitOfSale = tempActiveDepartment.value.unitOfSale
        compState.altLangText = altDisplayText(tempActiveDepartment.value.altDisplayLang)
    }
    console.log('tempActiveDepartment', tempActiveDepartment.value);

})

const compState = reactive({
    id: '',
    no: '',
    name: '',
    showOnMenu: false,
    saleDepartment: false,
    taxRate: '',
    displayOrder: 0,
    nonDiscountable: false,
    nonSurchargeable: false,
    scaleDepartment: false,
    unitOfSale: '',
    altLangText: ''
})

const altDisplayText = (langList: String[]) => {
    if (langList) {
        return langList.filter(lang => lang !== '').join('|')
    }
    return ''
}

const activeDepartment = computed(() => {
    return departmentsStore.getActiveDepartment
})

const tempActiveDepartment = computed(() => {
    return departmentsStore.getTempActiveDepartment
})

const activeDepartmentId = computed(() => {
    return departmentsStore.getActiveDepartmentId
})

watch(activeDepartmentId, (newVal) => {
    if (newVal) {
        const department = activeDepartment.value
        compState.id = department.id
        compState.no = department.no
        compState.name = department.name
        compState.showOnMenu = department.showOnMenu
        compState.saleDepartment = department.saleDepartment
        compState.taxRate = department.taxRate
        compState.displayOrder = department.displayOrder
        compState.nonDiscountable = department.nonDiscountable
        compState.nonSurchargeable = department.nonSurchargeable
        compState.scaleDepartment = department.scaleDepartment
        compState.unitOfSale = department.unitOfSale
        compState.altLangText = altDisplayText(tempActiveDepartment.value.altDisplayLang)
    }
}, { immediate: true });

watch(compState, (newVal) => {
    departmentsStore.setTempActiveDepartment({
        ...tempActiveDepartment.value,
        id: newVal.id,
        name: newVal.name,
        showOnMenu: newVal.showOnMenu,
        saleDepartment: newVal.saleDepartment,
        taxRate: newVal.taxRate,
        displayOrder: newVal.displayOrder,
        nonDiscountable: newVal.nonDiscountable,
        nonSurchargeable: newVal.nonSurchargeable,
        scaleDepartment: newVal.scaleDepartment,
        unitOfSale: newVal.unitOfSale,
    } as Department)
}, { deep: true });

const displayOrderIncrement = () => {
    compState.displayOrder++
}

const displayOrderDecrement = () => {
    if (compState.displayOrder > 0) {
        compState.displayOrder--
    }
}

const onEditAltLang = () => {
    compState.altLangText = altDisplayText(tempActiveDepartment.value.altDisplayLang)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h6", _hoisted_4, _toDisplayString(_unref(t)('DepartmentNumber')) + " : " + _toDisplayString(compState.no), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  id: "show-on-menu",
                  type: "checkbox",
                  value: "",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((compState.showOnMenu) = $event))
                }, null, 512), [
                  [_vModelCheckbox, compState.showOnMenu]
                ]),
                _createElementVNode("label", _hoisted_10, _toDisplayString(_unref(t)('ShowOnMenu')), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  id: "sele-department",
                  type: "checkbox",
                  value: "",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((compState.saleDepartment) = $event))
                }, null, 512), [
                  [_vModelCheckbox, compState.saleDepartment]
                ]),
                _createElementVNode("label", _hoisted_14, _toDisplayString(_unref(t)('SaleDepartment')), 1)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("label", null, [
            _createElementVNode("h6", _hoisted_18, _toDisplayString(_unref(t)('DepartmentName')), 1)
          ]),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((compState.name) = $event)),
            class: "form-control",
            type: "text",
            placeholder: _unref(t)('DepartmentName'),
            maxlength: "32"
          }, null, 8, _hoisted_19), [
            [_vModelText, compState.name]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("label", null, [
            _createElementVNode("h6", _hoisted_22, _toDisplayString(_unref(t)('AlternativeDisplayLanguage')), 1)
          ]),
          _withDirectives(_createElementVNode("input", {
            class: "form-control",
            type: "text",
            placeholder: _unref(t)('AlternativeDisplayLanguage'),
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((compState.altLangText) = $event)),
            maxlength: "32",
            readonly: "",
            "data-bs-toggle": "modal",
            "data-original-title": "test",
            "data-bs-target": "#alt-lang-modal"
          }, null, 8, _hoisted_23), [
            [_vModelText, compState.altLangText]
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("label", null, [
            _createElementVNode("h6", _hoisted_27, _toDisplayString(_unref(t)('Rate')), 1)
          ]),
          _createElementVNode("div", _hoisted_28, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((compState.taxRate) = $event)),
              class: "form-select",
              "aria-label": "Tax Rate"
            }, [
              _createElementVNode("option", _hoisted_29, _toDisplayString(_unref(t)('TaxRate')), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(taxList.value, (tax) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: String(tax.id),
                  value: tax.name
                }, _toDisplayString(tax.name), 9, _hoisted_30))
              }), 128))
            ], 512), [
              [_vModelSelect, compState.taxRate]
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_31, [
      _createElementVNode("div", _hoisted_32, [
        _createElementVNode("label", null, [
          _createElementVNode("h6", _hoisted_33, _toDisplayString(_unref(t)('DisplayOrder')), 1)
        ]),
        _createElementVNode("div", _hoisted_34, [
          _withDirectives(_createElementVNode("input", {
            class: "form-control",
            type: "number",
            placeholder: _unref(t)('Threshold'),
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((compState.displayOrder) = $event))
          }, null, 8, _hoisted_35), [
            [_vModelText, compState.displayOrder]
          ]),
          _createElementVNode("button", {
            class: "btn btn-outline-secondary rounded-end-0",
            type: "button",
            onClick: displayOrderDecrement
          }, "-"),
          _createElementVNode("button", {
            class: "btn btn-outline-secondary rounded-start-0",
            type: "button",
            onClick: displayOrderIncrement
          }, "+")
        ])
      ]),
      _createElementVNode("div", _hoisted_36, [
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  id: "service-check",
                  type: "checkbox",
                  value: "",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((compState.nonDiscountable) = $event))
                }, null, 512), [
                  [_vModelCheckbox, compState.nonDiscountable]
                ]),
                _createElementVNode("label", _hoisted_41, _toDisplayString(_unref(t)('NonDiscountable')), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("div", _hoisted_44, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  id: "surchargeable-check",
                  type: "checkbox",
                  value: "",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((compState.nonSurchargeable) = $event))
                }, null, 512), [
                  [_vModelCheckbox, compState.nonSurchargeable]
                ]),
                _createElementVNode("label", _hoisted_45, _toDisplayString(_unref(t)('NonSurchargeable')), 1)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_46, [
      _createElementVNode("div", _hoisted_47, [
        _createElementVNode("div", _hoisted_48, [
          _createElementVNode("div", _hoisted_49, [
            _withDirectives(_createElementVNode("input", {
              class: "form-check-input",
              id: "scale-check",
              type: "checkbox",
              value: "",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((compState.scaleDepartment) = $event))
            }, null, 512), [
              [_vModelCheckbox, compState.scaleDepartment]
            ]),
            _createElementVNode("label", _hoisted_50, _toDisplayString(_unref(t)('ScaleDepartment')), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_51, [
        _createElementVNode("div", _hoisted_52, [
          _createElementVNode("label", null, [
            _createElementVNode("h6", _hoisted_53, _toDisplayString(_unref(t)('UnitOfSale')), 1)
          ]),
          _createElementVNode("div", _hoisted_54, [
            _withDirectives(_createElementVNode("select", {
              class: "form-select",
              "aria-label": "Tax Rate",
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((compState.unitOfSale) = $event))
            }, [
              _createElementVNode("option", _hoisted_55, _toDisplayString(_unref(t)('UnitOfSale')), 1),
              _createElementVNode("option", _hoisted_56, _toDisplayString(_unref(t)('Individually')), 1),
              _createElementVNode("option", _hoisted_57, _toDisplayString(_unref(t)('Gram')), 1),
              _createElementVNode("option", _hoisted_58, _toDisplayString(_unref(t)('Kilogram')), 1),
              _createElementVNode("option", _hoisted_59, _toDisplayString(_unref(t)('Ounce')), 1),
              _createElementVNode("option", _hoisted_60, _toDisplayString(_unref(t)('Pound')), 1),
              _createElementVNode("option", _hoisted_61, _toDisplayString(_unref(t)('Milliliter')), 1),
              _createElementVNode("option", _hoisted_62, _toDisplayString(_unref(t)('Liter')), 1),
              _createElementVNode("option", _hoisted_63, _toDisplayString(_unref(t)('Pint')), 1),
              _createElementVNode("option", _hoisted_64, _toDisplayString(_unref(t)('Quart')), 1),
              _createElementVNode("option", _hoisted_65, _toDisplayString(_unref(t)('Gallon')), 1)
            ], 512), [
              [_vModelSelect, compState.unitOfSale]
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_unref(departmentsAltLangModal), { onOnSave: onEditAltLang })
  ], 64))
}
}

})